import '../custom.css';
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useParams  } from 'react-router';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import logo from '../components/Images/logo.png';
import { useToken } from '../components/items/UseToken'


export default function ResetPassword () {
    const [retypePassword, setRetypePassword] = useState();
    const [newPassword, setPassword] = useState();
    const [loginErrorMessage, setLoginErrorMessage] = useState();
    const [loginStatusCode, setLoginStatusCode] = useState();
    const { token, setToken } = useToken();
    const navigate = useNavigate();
    const { magicKey } = useParams();
    const handleSubmit = async e => {
        e.preventDefault();
        if (retypePassword == newPassword) {
            console.log("password ok");

        }
        else {
            console.log("password mismatch");

        }

        resetPassword({
            magicKey,
            newPassword
        });
        
    }
    function resetPassword(credentials) {
        fetch('api/resetpassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(credentials)
        })
            .then(data => {
                if (data.status != 200) {
                    data.json()
                        .then((error) => {
                            setLoginStatusCode(data.status)
                            setLoginErrorMessage(error.errors)

                        })

                }
                else {
                    data.json()
                        .then((res) => {
                            let loginCreds = { username: res.user, password: newPassword }
                            loginUser(loginCreds);
                            navigate("/");

                        })
                }




            })
            

    }

    function loginUser(credentials) {
        let fetchUrl = "api/login";
       
        fetch(fetchUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(credentials)
        })
            .then(data => {
                if (data.status != 200) {
                    data.json()
                        .then((error) => {
                            setLoginStatusCode(data.status)
                            setLoginErrorMessage(error.errors)

                        })

                }
                else {
                    data.json()
                        .then((data) => {
                           
                                setToken(data);
                            
                        })
                }




            })


    }

    useEffect(() => {
        if (newPassword)
        navigate("/");
    }, [token])

    return (

        <Box mt={2}
                    component="form"
                    sx={{
                        '& .MuiTextField-root': { m: 1, width: '25ch' },
                    }}
                    noValidate
                    autoComplete="off">
            <div className="login-wrapper">
                <Card sx={{ maxWidth: 700, textAlign:'center' }}>
                    <CardMedia
                        component="img"
                        alt="green iguana"
                        height="140"
                        className="loginCard"
                        image={logo}
                    />
                    <CardContent>
                        <Box sx={{ textAlign: '-webkit-center', width: '100%' }}>
                            {loginStatusCode && loginStatusCode != 200  &&
                                <Typography color="error" variant="body2" gutterBottom>
                                    {loginStatusCode + ": " + loginErrorMessage}
                                </Typography>
                            }
                        <Typography variant="h5" gutterBottom>
                            New Password Setup
                            </Typography>
                            </Box>
                    </CardContent>
                    <CardActions sx={{ display: 'inline-grid' }}>
                        
                            
                            
                        <TextField
                            required
                            value={retypePassword}
                            id="password-input"
                            label="New Password"
                            type="password"
                            onChange={e => setRetypePassword(e.target.value)}
                        />

                                <TextField
                                    required
                                    value={newPassword}
                                    id="password-input"
                                    label="Confirm New Password"
                                    type="password"
                                    onChange={e => setPassword(e.target.value)}
                                />
                            

                        <Button disabled={newPassword && retypePassword ? false : true} size="large" type="submit" onClick={handleSubmit} variant="contained" color='neutral' >
                                    Save New Password
                                </Button>
                            
                       
                    </CardActions>
                </Card>
                        
                    </div>
                </Box>

         


        
    )
}

